import { commonSlice } from './commonSlice'

export const { clearAllStates, setDrawerVisible } = commonSlice.actions

export const commonReducer = commonSlice.reducer
